interface DynamicObject<T> {
  [key: string]: T;
}

export interface DataLayerData<T> {
  event: string;
  data: DynamicObject<T>;
}

declare global {
  interface Window {
    dataLayer: Array<Record<string, any>>;
  }
}

export const pushToDataLayer = <T>({ event, data }: DataLayerData<T>) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({ event: event, ...data });
};

export const incrementDataLayerEvent = <T>({
  event,
  data,
}: DataLayerData<T>) => {
  if (typeof window === 'undefined' || typeof sessionStorage === 'undefined')
    return;

  const sessionItem = sessionStorage.getItem(event);
  const count = sessionItem ? Number(sessionItem) + 1 : 1;
  sessionStorage.setItem(event, count.toString());

  pushToDataLayer({
    event,
    data: {
      ...data,
      [event]: count, // Add the dynamic key
    },
  });
};
